/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';

import PasswordSupportSection from './PasswordSupportSection';
import SupportContactSection from 'src/shared/app/authentication/component/support/contact/SupportContactSection';
import ForgotPasswordSection from './forgot/ForgotPasswordSection';
import LoginLinkSection from 'src/shared/app/authentication/component/support/login/link/LoginLinkSection';
import messages from 'src/shared/app/authentication/l10n/authenticationSupportL10n';
import DocumentTitle from 'src/shared/app/base/component/document/DocumentTitle';

type Props = {
  isLoginLinkDisabled: boolean,
  showLink: boolean,
  showReset: boolean,
  showContact: boolean,
  handleLoginLinkClick: () => void,
  handleResetPasswordClick: () => void,
  handleContactClick: () => void,
  handleBack: () => void,
};

const PasswordSupportMainDumb = ({
  isLoginLinkDisabled,
  showLink,
  showReset,
  showContact,
  handleLoginLinkClick,
  handleResetPasswordClick,
  handleContactClick,
  handleBack,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  let sectionElt = (
    <PasswordSupportSection
      isLoginLinkDisabled={isLoginLinkDisabled}
      handleLinkClick={handleLoginLinkClick}
      handleResetPasswordClick={handleResetPasswordClick}
      handleContactClick={handleContactClick}
    />
  );

  if (showLink) {
    sectionElt = (
      <LoginLinkSection
        handleBack={handleBack}
        handleHelpClick={handleContactClick}
      />
    );
  } else if (showReset) {
    sectionElt = (
      <ForgotPasswordSection
        handleBack={handleBack}
        handleHelpClick={handleContactClick}
      />
    );
  } else if (showContact) {
    sectionElt = <SupportContactSection handleBack={handleBack} />;
  }

  return (
    <React.Fragment>
      <DocumentTitle>
        {intl.formatMessage(messages.passwordSupportTitle)}
      </DocumentTitle>
      {sectionElt}
    </React.Fragment>
  );
};

export default compose(React.memo)(PasswordSupportMainDumb);
